module.exports = __webpack_public_path__ + "static/img/372.f506a88.png";